import { apiGet } from 'api';
import { Organisation } from 'types';
import { GetParentOrganisationRequest } from '../';

export const getParentOrganisation = (
  request: GetParentOrganisationRequest
): Promise<Organisation> =>
  apiGet<Organisation, GetParentOrganisationRequest>(
    `admin/parentorganisations/${request.id}`,
    request
  );
